import { CSSProperties } from 'react'
import {
  maxMobileScreenWidth,
  minDesktopScreenWidth
} from 'src/utils/breakpoints'
import styled from 'styled-components'

export type TagVariant = 'blue' | 'purple' | 'yellow' | 'green' | 'gray'

const getColorsByVariant = (
  tagVariant: TagVariant
): {
  color: CSSProperties['color']
  background: CSSProperties['background']
} => {
  switch (tagVariant) {
    case 'blue':
      return {
        color: '#ffffff',
        background: '#009fdf'
      }
    case 'purple':
      return {
        color: '#ffffff',
        background: '#7b61ff'
      }
    case 'yellow':
      return {
        color: '#000000',
        background: '#e5b01d'
      }
    case 'green':
      return {
        color: '#ffffff',
        background: '#2ca24f'
      }
    case 'gray':
      return {
        color: '#ffffff',
        background: '#6d6f71'
      }
    default:
      return {
        color: '#000000',
        background: '#ffffff'
      }
  }
}

export const Tag = styled.p<{ $tagVariant: TagVariant }>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-family: Rubik;
  border-radius: 32px;

  padding: 0 8px;
  width: max-content;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    font-size: 12px;
    height: 24px;
  }

  @media only screen and (min-width: ${minDesktopScreenWidth}px) {
    width: fit-content;
    padding: 6px 8px;

    &.smaller {
      width: 12%;
    }
  }

  ${(props) => {
    const colors = getColorsByVariant(props.$tagVariant)
    return `
      background: ${colors.background};
      color: ${colors.color};
    `
  }}
`
